export default __webpack_public_path__ + "static/media/wafer-bg-top.c5d4500c.png";